import { useEffect, useRef, useState } from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { NUM } from "@/lib/format";
import { cn } from "@/lib/utils";

const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

/** Depo | Mağaza kaydırıcısı: sol (lacivert-gri) = Depo, sağ (teal) = Mağaza. Bırakınca fark kadar ANINDA aktarma yapılır. */
export function SplitSlider({ depo, magaza, unit, onCommit, testid, compact = false }) {
  const total = r2(depo + magaza);
  const [d, setD] = useState(depo);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setD(depo); }, [depo, magaza]);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const off = total <= 0 || depo < 0 || magaza < 0;
  const step = Number.isInteger(total) && Number.isInteger(depo) ? 1 : 0.01;
  const send = async (nd) => {
    const target = r2(nd);
    if (target === r2(depo)) return;
    setBusy(true);
    try { await onCommit(target < depo ? { to: "magaza", qty: r2(depo - target) } : { to: "depo", qty: r2(target - depo) }); }
    catch { setD(depo); }
    finally { setBusy(false); }
  };
  // Klavye oklarında her basış ayrı aktarma olmasın: son konum kısa bir bekleme sonrası tek seferde gönderilir
  const commit = ([nd]) => { clearTimeout(timer.current); timer.current = setTimeout(() => send(nd), 450); };
  if (off) return <div className="text-[10px] text-slate-400 text-center" data-testid={testid}>{total <= 0 ? "stok yok" : "eksi stok"}</div>;
  return (
    <div className={cn("w-full", compact ? "min-w-[110px]" : "min-w-[150px]")} data-testid={testid}>
      <SliderPrimitive.Root value={[d]} min={0} max={total} step={step} disabled={busy} onValueChange={([v]) => setD(v)} onValueCommit={commit}
        className="relative flex w-full touch-none select-none items-center h-5 cursor-grab active:cursor-grabbing" aria-label="Depo / Mağaza dağılımı">
        <SliderPrimitive.Track className="relative h-2.5 w-full grow overflow-hidden rounded-full bg-teal-500">
          <SliderPrimitive.Range className="absolute h-full bg-slate-500" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className={cn("block h-4 w-4 rounded-full border-2 border-white bg-[#0F2745] shadow-md ring-1 ring-slate-300 transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705]", busy && "animate-pulse")} data-testid={testid ? `${testid}-thumb` : undefined} />
      </SliderPrimitive.Root>
      <div className="flex justify-between text-[10px] font-semibold tnum leading-3 mt-0.5">
        <span className="text-slate-600">D {NUM(r2(d))}</span>
        <span className="text-teal-700">M {NUM(r2(total - d))}{!compact && unit ? ` ${unit}` : ""}</span>
      </div>
    </div>
  );
}
